import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    let opencampusSearch = $('#opencampus-search');
    if (opencampusSearch.length) {
        const searchCategoryList = opencampusSearch.find('.search-category-list');
        searchCategoryList.on('click', 'a', function (e) {
            e.preventDefault();
            // Clear preloaded flag on filter change
            opencampusSearch.data('preloaded', false);
            searchCategoryList.find('.item-all').removeClass('active');
            $(this).toggleClass('active');
            if ($(this).data('category-id') == "0") {
                searchCategoryList.find('a').removeClass('active');
                $(this).addClass('active');
            }
            if (searchCategoryList.find('a.active').not('.item-all').length === 0) {
                searchCategoryList.find('.item-all').addClass('active');
            }
            ajaxSearchOpenCampus();
        });
        const searchTagList = opencampusSearch.find('.search-tag-list');
        searchTagList.on('click', 'a', function (e) {
            e.preventDefault();
            // Clear preloaded flag on filter change
            opencampusSearch.data('preloaded', false);
            searchTagList.find('.item-all').removeClass('active');
            $(this).toggleClass('active');
            if ($(this).data('tag-id') == "0") {
                searchTagList.find('a').removeClass('active');
                $(this).addClass('active');
            }
            if (searchTagList.find('a.active').not('.item-all').length === 0) {
                searchTagList.find('.item-all').addClass('active');
            }
            ajaxSearchOpenCampus();
        });
        const schoolSearchList = opencampusSearch.find('.school-search-list');
        schoolSearchList.on('click', 'a', function (e) {
            e.preventDefault();
            // Clear preloaded flag on filter change
            opencampusSearch.data('preloaded', false);
            schoolSearchList.find('.item-all').removeClass('active');
            $(this).toggleClass('active');
            if ($(this).data('school-id') == "0") {
                schoolSearchList.find('a').removeClass('active');
                $(this).addClass('active');
            }
            if (schoolSearchList.find('a.active').not('.item-all').length === 0) {
                schoolSearchList.find('.item-all').addClass('active');
            }
            ajaxSearchOpenCampus();
        });
        const searchDateList = opencampusSearch.find('.search-date-list');
        searchDateList.on('click', 'a', function (e) {
            e.preventDefault();
            // Clear preloaded flag on filter change
            opencampusSearch.data('preloaded', false);
            const isActive = $(this).hasClass('active');
            searchDateList.find('a').removeClass('active');
            if (!isActive) {
                $(this).addClass('active');
            }
            ajaxSearchOpenCampus(1);
        });

        const loadMoreBtn = opencampusSearch.find('.handle-load-more');
        loadMoreBtn.on('click', function (e) {
            e.preventDefault();
            var nextPage = $(this).data('next-page');
            ajaxSearchOpenCampus(nextPage);
        });

        // Initial load: skip AJAX if data is pre-loaded from server
        const isPreloaded = opencampusSearch.data('preloaded') === true;
        if (!isPreloaded) {
            ajaxSearchOpenCampus(1);
        }
    }
    const { scrollSticky } = await import('../components/scroll-sticky-bottom.js');
    scrollSticky();

    const subjectFilterButtons = document.querySelectorAll('#subject-filter .e-btn--ctrl');
    const openCampusBlocks = document.querySelectorAll('.c-block__detail');
    if (!subjectFilterButtons.length) return;

    subjectFilterButtons.forEach(button => {
        button.addEventListener('click', () => {
            subjectFilterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            const selectedSubjectId = button.dataset.subjectId;
            openCampusBlocks.forEach(block => {
            block.style.display =
                !selectedSubjectId || block.dataset.subjectIds.split(',').includes(selectedSubjectId)
                ? ''
                : 'none';
            });
        });
    });
});

function checkData(response) {
  console.clear();
  response.data.forEach(function (item) {
    console.info(item.id, item.entry_event_at);
  });
}

function ajaxSearchOpenCampus(page = 1) {
    let opencampusSearch = $('#opencampus-search');
    const searchCategoryList = opencampusSearch.find('.search-category-list');
    var categories = [];
    searchCategoryList.find('a').each(function () {
        if ($(this).hasClass('active')) {
            var category = $(this).data('category-id');
            categories.push(category);
        }
    });
    categories = categories.join(',');

    const searchTagList = opencampusSearch.find('.search-tag-list');
    var tags = [];
    searchTagList.find('a').each(function () {
        if ($(this).hasClass('active')) {
            var tag = $(this).data('tag-id');
            tags.push(tag);
        }
    });
    tags = tags.join(',');

    const schoolSearchList = opencampusSearch.find('.school-search-list');
    var schools = [];
    schoolSearchList.find('a').each(function () {
        if ($(this).hasClass('active')) {
            var school = $(this).data('school-id');
            schools.push(school);
        }
    });
    schools = schools.join(',');

    const searchDateList = opencampusSearch.find('.search-date-list');
    var dates = [];
    searchDateList.find('a').each(function () {
        if ($(this).hasClass('active')) {
            var date = $(this).data('date');
            dates.push(date);
        }
    });
    dates = dates.join(',');

    $.ajax({
        url: opencampusSearch.data('url'),
        type: 'GET',
        data: {
            type: opencampusSearch.data('type'),
            category: categories,
            tag: tags,
            school: schools,
            date: dates,
            page: page,
        },
        beforeSend: function () {
            // if (page == 1) {
            //     opencampusSearch.find('.search-results').html('');
            // }
            // opencampusSearch.find('.search-results').html('<p>Loading...</p>');
        },
        success: function (response) {
            if (page == 1) {
                opencampusSearch.find('.search-date-list').html('');
                opencampusSearch.find('.search-results').html('');
            }

            // Slide dates
            var html_date = ``;
            if (response.dates == undefined || response.dates.length == 0) {
                opencampusSearch.find('.search-date-list-wrap-no-item').show();
                opencampusSearch.find('.search-date-list-wrap').hide();
            }

            opencampusSearch.find('.search-date-list-wrap-no-item').hide();
            opencampusSearch.find('.search-date-list-wrap').show();
            response.dates.forEach(function (item) {
              let active = dates == item.date ? 'active' : '';
              html_date += `<div class="swiper-slide">
                <a href="#" class="c-search__card ` + active + ' ' + item.type + ' ' + item.weekday + `" data-date="` + item.date +`">
                  <span class="c-search__card-date">` + item.date_label +`</span>
                  <span class="c-search__card-txt">` + item.label +`</span>
                </a>
              </div>`;
            });
            opencampusSearch.find('.search-date-list').html(html_date);

            // Results
            var html = ``;
            if (response.total == undefined || response.data.length == 0) {
                opencampusSearch.find('.search-results-no-item').show();
                opencampusSearch.find('.result-total').text(0);
                opencampusSearch.find('.handle-load-more').hide();
                return;
            }
            opencampusSearch.find('.search-results-no-item').hide();
            response.data.forEach(function (item) {
                var date = item.dates ? item.dates.map(function(dateItem, index, arr) {
                    return `<li class="c-search-result__date">` + dateItem + (index < arr.length - 1 ? `,` : ``) + `</li>`;
                }).join('') : '';
                var label = item.label ? item.label.map(function(item) {
                    return `<span class="c-box__tag">` + item + `</span>`;
                }).join('') : '';
                var thumbnail = item.header_image ? item.header_image : '/assets/img/opencampus/bnr_toho_search_dummy.jpg';
                html += `<div class="c-search-result__item">
                            <a href="` + item.url + `" class="c-search-result__link" aria-label="` + item.event_name + `">
                                <img src="` + thumbnail + `" width="256" height="260" loading="lazy" alt="` + item.event_name + `">
                            </a>
                            <ul class="c-search-result__date-list">` + date + `</ul>
                                <nav class="c-box__tag-list">` + label + `</nav>
                        </div>`;
            });
            opencampusSearch.find('.search-results').append(html);
            opencampusSearch.find('.result-total').text(response.total);

            if (response.last_page > page) {
                opencampusSearch.find('.handle-load-more').show();
                opencampusSearch.find('.handle-load-more').data('next-page', response.current_page + 1);
            } else {
                opencampusSearch.find('.handle-load-more').hide();
            }
        },
        error: function () {
          opencampusSearch.find('.search-date-list').html('<p>An error occurred while fetching data.</p>');
            opencampusSearch.find('.search-results').html('<p>An error occurred while fetching data.</p>');
        }
    });

}
